module.exports = __webpack_public_path__ + "img/ico_biaoqiajunshi.e03a38fc.png";